import { ActionReducerMap } from '@ngrx/store';
import { NotificationsModuleState } from './notifications.reducer';

export * from './notifications.actions';
export * from './notifications.models';
export * from './notifications.reducer';
export * from './notifications.selectors';
export * from './notifications.effects';

import * as fromNotifications from './notifications.reducer';

export const reducers: ActionReducerMap<fromNotifications.NotificationsModuleState> = {
  notifications: fromNotifications.reducer
};
